import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Content = styled.div`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  color: #000;
  padding: 1rem;
`;

export const TableContainer = styled.div`
  overflow-x: auto;
`;

export const InputContainer = styled.div`
  margin: 1rem 0;
`;

export const Line = styled.div`
  display: grid;
  flex-direction: row;
  grid-template-columns: repeat(4, 1fr);
  min-height: 40px;
  border-bottom: 1px solid #A1A1A1;
  font-weight: ${props => props.header ? '700' : '500'};
  ${props => props.header && 'background-color: #E2E2E2;'}

  div {
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
  }

  button{
    padding: 10px 20px;
    background-color: #C2C2C2;
    border: 1px solid #000;
    border-radius: 5px;
    cursor: pointer;
    font-weight: 600;
  }
`;

export const ButtonOpen = styled.button`
  cursor: pointer;
  background-color: #3c3cff;
  color: #fff;
  padding: 5px 10px;
  border-radius: 5px;
  border: none;
  font-weight: 700;
`;


export const Center = styled.div`
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: ${props => props.space ? 'space-between' : 'center'};
`;


export const Nav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  nav{
    display: flex;
    flex-direction: column;
    flex: 1;
    max-width: 50%;
    align-items: flex-end;

    .filter_container{
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      margin-bottom: 10px;
    }
}
`;

export const Button = styled.button`
  background-color: var(--color-primary);
  color: #fff;
  padding: 0.8rem 1.5rem;
  border-radius: 5px;
  border: none;
  font-weight: 700;
  font-size: 1rem;
  cursor: pointer;
  max-width: fit-content;
  ${({ disabled }) => disabled && ({ opacity: 0.5, cursor: 'not-allowed' })}

  &:hover {
    ${({ disabled }) => !disabled && 'background-color: var(--color-primary-dark)'}

  }
`;
